import { Tooltip } from '@mui/material';
import { UserRoles } from '../AuthDataProvider';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import PersonIcon from '@mui/icons-material/Person';
import SaveIcon from '@mui/icons-material/Save';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import SettingsIcon from '@mui/icons-material/Settings';
interface IUserRoleProps {
    role: UserRoles
}

export default function UserRole(props: IUserRoleProps) {
    switch (props.role) {
        case UserRoles.admin:
            return (
                <div style={{ display: 'inline-flex' }}>
                    <Tooltip title="Admin">
                        <SupervisorAccountIcon />
                    </Tooltip>
                </div>
            )
        case UserRoles.fleetweb:
            return (
                <div style={{ display: 'inline-flex' }}>
                    <Tooltip title="User">
                        <PersonIcon />
                    </Tooltip>
                </div>
            )
        
        case UserRoles.firmware:
            return (
                <div style={{ display: 'inline-flex' }}>
                    <Tooltip title="Firmware">
                        <SaveIcon />
                    </Tooltip>
                </div>
            )
        case UserRoles.support:
            return (
                <div style={{ display: 'inline-flex' }}>
                    <Tooltip title="Support">
                        <ContactSupportIcon />
                    </Tooltip>
                </div>
            )
        case UserRoles.config:
            return (
                <div style={{ display: 'inline-flex' }}>
                    <Tooltip title="Config">
                        <SettingsIcon />
                    </Tooltip>
                </div>
            )
        default:
            return (<div>{props.role}</div>)
    }

}